import { Theme } from '@mui/material';

type DrawerComponentType = {
  styleOverrides: {
    paper: () => Record<string, unknown>;
    paperAnchorBottom: () => Record<string, unknown>;
  };
};

export const getDrawerOptions = ({ palette }: Theme): { drawerComponent: DrawerComponentType } => {
  const drawerComponent = {
    styleOverrides: {
      paper: () => {
        return {
          backgroundColor: palette.contentBlockBackground.secondary,
          border: `1px solid ${palette.modal.border}`,
          padding: '16px',
          boxShadow: 'none',
          backgroundImage: 'none',
        };
      },
      paperAnchorBottom: () => {
        return {
          borderRadius: '20px 20px 0 0',
        };
      },
    },
  };

  return { drawerComponent };
};
